import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { getResearchPerfEvalCriteriaOptions } from '@/module/ResearchPerfEval/model/ResearchPerfEvalQuery';

import { NoContentPlaceholder } from '@/core/components';

export const Route = createFileRoute('/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { evaluationId } = Route.useParams();
  const { data: criteria } = useSuspenseQuery(getResearchPerfEvalCriteriaOptions(evaluationId));
  const navigate = Route.useNavigate();

  useEffect(() => {
    if (criteria.length > 0) {
      navigate({
        to: `/research-perf-eval/$evaluationId/report/gather/$orderNo`,
        params: { evaluationId, orderNo: String(criteria[0].orderNo) },
        search: true,
      });
    }
  }, [evaluationId, criteria, navigate]);

  return <NoContentPlaceholder title="Fara continut" />;
}
